import { render } from "./PayRollSelector.vue?vue&type=template&id=128cb11a&scoped=true"
import script from "./PayRollSelector.vue?vue&type=script&lang=js"
export * from "./PayRollSelector.vue?vue&type=script&lang=js"

import "./PayRollSelector.vue?vue&type=style&index=0&id=128cb11a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128cb11a"]])

export default __exports__